import { api } from './api';

export const getDetailedHealth = () => api.get('/health/detailed');
